import PlayerConstants from "../../../shared/constants/player";
const { BINGE_WATCH_CARD_THRESHOLD } = PlayerConstants;

export const playerGetBingeWatchCountdownTime = (isVOD, isRecording, playerMgr) => {
  return isVOD || isRecording ? ((100 - BINGE_WATCH_CARD_THRESHOLD) * playerMgr?.current?.getDuration()) / 100 : null;
};

export const playerHandleStaticSeeking = (playerMgr, newPos) => {
  playerMgr.current?.seek(newPos);
};

export const playerGetSeekParameters = (playerMgr) => {
  const currentPos = playerMgr.current?.getCurrentTime();
  const videoDuration = playerMgr.current?.getDuration();
  return { currentPos, videoDuration };
};

export const playerCalculateSeekPosition = (currentPos, seekTarget, appendCurrentPos) => {
  let newPos = seekTarget;
  if (appendCurrentPos) {
    newPos = currentPos + seekTarget > 0 ? currentPos + seekTarget : 0;
  }
  return newPos;
};

export const playerSeekableEndPos = (videoDuration) => {
  return videoDuration - 1;
};
